import { z } from 'zod';

const SerializedEditorStateSchema = z.record(z.any());

// Agreement schema
export const AgreementSchema = z
  .object({
    content: SerializedEditorStateSchema.optional(),
  });

export type AgreementInputValues = z.input<typeof AgreementSchema>;
export type AgreementOutputValues = z.output<typeof AgreementSchema>;
